import {Form, Switch} from 'antd';
import React from "react";
import {IFieldOptionsEditorProps} from "../FieldOptionsEditor";
import LocaleText from "../../../../settings/dictionary/LocaleText";

export interface IFieldEmailOptions {
    emailLink?: boolean
}

interface IProps extends IFieldOptionsEditorProps {

}

class FieldEmailOptionsEditor extends React.Component<IProps> {

    render() {
        const {buildFieldName} = this.props
        return (
            <div>
                <Form.Item name={buildFieldName('emailLink')} label={<LocaleText code={'configuration.field.email.options.email-link'} fallback={'Zobrazit jako odkaz'}/>} valuePropName={'checked'}>
                    <Switch/>
                </Form.Item>
            </div>
        )
    }
}


export default FieldEmailOptionsEditor